import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEmoji$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEmoji extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2a0630e6f0635c06dcdbcdf5144f985c4a01fda6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7fdc475f756bf03b9c87191344e4ffd76fa3440b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '2d7a2f4637bac76665713b0c4a830aff3d8ca311', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 11a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9 5.5A5.75 5.75 0 0 1 5.707 13h10.586A5.75 5.75 0 0 1 11 16.5m3-9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M6.5 9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-emoji", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-emoji"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-emoji":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEmoji$1);
            }
            break;
    } });
}

const CosmosIconEmoji = CosmosIconEmoji$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEmoji, defineCustomElement };
